import { IAuthenticationModuleConfiguration } from 'src/modules/authentication_module';
import { IInteractionModuleConfiguration } from 'src/modules/interaction_module';
import { INavigationModuleConfiguration } from 'src/modules/navigation_module';
import { IProductModuleConfiguration } from 'src/modules/product_module';
import { ILoggingModuleConfiguration } from 'src/modules/logging_module';
import { INetworkModuleConfiguration } from '../modules/network_module';
import { ISessionModuleConfiguration } from '../modules/session_module';
import { IViewModuleConfiguration } from 'src/modules/view_module';
import { IMenuModuleConfiguration } from '../modules/menu_module';
import { ISentryModuleConfiguration } from '../modules/sentry_module';
import { IHistoryModuleConfiguration } from '../modules/history_module';
import { ILoadingModuleConfiguration } from '../modules/loading_module';
import { IAnalyticsModuleConfiguration } from '../modules/analytics_module';
import { IModuleConfiguration } from 'src/types/system_types';
import { IMiddlewareConfiguration } from './middleware';
import { Hosting } from './ahp';

import tt from'../../../pip/library/pi-tt/pi-tt.js';

export type t_ahp_configuration =
  | 'authentication'
  | 'interaction'
  | 'network'
  | 'navigation'
  | 'session'
  | 'product'
  | 'logging'
  | 'menu'
  | 'view'
  | 'sentry'
  | 'history'
  | 'loading'
  | 'analytics';

export interface IAHPConfiguration extends Record<t_ahp_configuration, IModuleConfiguration> {
  authentication: IAuthenticationModuleConfiguration;
  interaction: IInteractionModuleConfiguration;
  navigation: INavigationModuleConfiguration;
  network: INetworkModuleConfiguration;
  session: ISessionModuleConfiguration;
  product: IProductModuleConfiguration;
  logging: ILoggingModuleConfiguration;
  view: IViewModuleConfiguration;
  menu: IMenuModuleConfiguration;
  sentry: ISentryModuleConfiguration;
  history: IHistoryModuleConfiguration;
  loading: ILoadingModuleConfiguration;
  analytics: IAnalyticsModuleConfiguration;
  middleware: IMiddlewareConfiguration;
}

export class AHPConfiguration {
  private __configuration: IAHPConfiguration;

  constructor(public ahp: Hosting) {}

  assign(key: string, configuration: IModuleConfiguration) {
    this.__configuration[key] = Object.assign({}, configuration);
    return this;
  }

  disseminateToModules(activeModules: string[] = this.ahp.systemNames) {
    const ahp = this.ahp;
    const conf = this._;

    tt.each((moduleName) => {
      ahp[moduleName].configuration = tt.mergeWith(
        'clobber',
        ahp[moduleName].configuration || {},
        conf[moduleName] || {}
      );
    }, activeModules);

    return this;
  }

  write(configuration: IAHPConfiguration) {
    this.__configuration = Object.assign(
      {
        authentication: {},
        interaction: {},
        network: {},
        navigation: {},
        session: {},
        product: {},
        logging: {},
        view: {},
        menu: {},
        sentry: {},
        history: {},
        loading: {},
        analytics: {},
        middleware: {}
      },
      configuration
    );

    return this;
  }

  read(path: string) {
    return tt.get(path, this.__configuration) || {};
  }

  get _() {
    return this.__configuration;
  }

  clear() {
    this.__configuration = {} as IAHPConfiguration;
    return this;
  }
}
